// extracted by mini-css-extract-plugin
export var actions = "_4l-0";
export var actionsContainer = "_4l-7";
export var border = "_4l-1";
export var childFullHeight = "_4l-f";
export var collapse = "_4l-2";
export var content = "_4l-a";
export var contentChild = "_4l-e";
export var fullscreen = "_4l-c";
export var hasLeftRadius = "_4l-k";
export var headerContainer = "_4l-3";
export var headerRow = "_4l-5";
export var hidePadding = "_4l-b";
export var navCollapsedGap = "_4l-l";
export var noScrollX = "_4l-m";
export var noScrollY = "_4l-n";
export var noTopPadding = "_4l-i";
export var optOutTopPadding = "_4l-d";
export var pageMain = "_4l-j";
export var pageOuter = "_4l-g";
export var pagePadding = "_4l-8";
export var pageScroll = "_4l-9";
export var profile = "_4l-o";
export var profileContainer = "_4l-p";
export var profileImage = "_4l-q";
export var profileMain = "_4l-r";
export var profileSubtitle = "_4l-t";
export var profileTitle = "_4l-s";
export var showLeftPadding = "_4l-h";
export var tabsPortalSlot = "_4l-6";
export var tabsWrapper = "_4l-4";
export var title = "_4l-u";